import { useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, Sparkles, Loader2 } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { id as localeId } from "date-fns/locale";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const TONES = [
  "from-pink-300 to-rose-300", "from-sky-300 to-cyan-200", "from-violet-300 to-pink-200",
  "from-amber-200 to-pink-300", "from-emerald-200 to-sky-200", "from-rose-200 to-fuchsia-300",
];
export const toneFor = (k) => TONES[[...k].reduce((a, c) => a + c.charCodeAt(0), 0) % TONES.length];

const ago = (s) => {
  const d = new Date(s);
  return isNaN(d) ? "" : formatDistanceToNow(d, { addSuffix: true, locale: localeId });
};

export const ArticleCard = ({ a, index }) => {
  const [summary, setSummary] = useState(a.summary);
  const [busy, setBusy] = useState(false);

  const summarize = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/news/summary", { link: a.link, title: a.title, description: a.description, keyword: a.keyword });
      setSummary(data.summary);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.35, delay: (index % 4) * 0.05 }}
      className="card-soft !p-0 overflow-hidden flex flex-col"
      data-testid={`article-card-${index}`}
    >
      <div className={`h-2 bg-gradient-to-r ${toneFor(a.keyword)}`} />
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-[11px] mb-2">
          <span className="px-2.5 py-1 rounded-full bg-pink-50 border border-pink-200 text-pink-700 font-semibold capitalize">{a.keyword}</span>
          <span className="text-gray-400 truncate">{a.source} · {ago(a.published)}</span>
        </div>
        <h3 className="font-heading text-lg font-medium text-gray-800 leading-snug">{a.title}</h3>
        {summary && <p className="text-sm text-gray-600 mt-3 bg-pink-50/70 rounded-2xl p-3 leading-relaxed" data-testid={`article-summary-${index}`}>{summary}</p>}
        <div className="flex gap-2 mt-auto pt-4">
          {!summary && (
            <button onClick={summarize} disabled={busy} className="chip chip-off" data-testid={`article-summarize-${index}`}>
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} Ringkas otomatis
            </button>
          )}
          <a href={a.link} target="_blank" rel="noopener noreferrer" className="chip chip-on" data-testid={`article-read-${index}`}>
            Baca <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </motion.article>
  );
};
